import React, { useEffect, useState } from "react";
import { MultiSelect } from "react-multi-select-component";
import DateRangeSelector from "./DateRangeSelector";
import "./draftbanner.css";
import Loader from '../images/whiteloader.svg';

const FilterPanel = ({filterName, accounts, filters, setFilters, onSearch, loading}) => {
    const [selectedAccount, setSelectedAccount] = useState([]);

    useEffect(() => {
      setSelectedAccount(filters.accounts.map(i => ({label: i, value: i})))
    }, [])

    const AccountsOptions = accounts.map(i => ({label: i, value: i}));

  return (
    <div className="filter-panel bg-white shadow-sm filter-header-financials">
      <h5 className="fw-bold filter-heading ">{filterName} Filters</h5>

      <div>
        <div>
          <label className="form-label">Account</label>
          <MultiSelect
            options={AccountsOptions}
            value={selectedAccount}
            onChange={async w => {
              const d = { ...filters, accounts: w.map(s => s.label) };
              setFilters(d);
              setSelectedAccount(w);
            }}
            labelledBy="Select"
          />
        </div>

        <div>
          <DateRangeSelector filters={filters} setFilters={setFilters} />
        </div>

        <div className="filter-search-button">
            <button type="button" className="btn btn-primary" disabled={loading} style={{ display : 'flex', placeSelf: 'center' }} onClick={onSearch}>
                {loading ? <img src={Loader} height="30" /> : 'Search'}
            </button>
        </div>

        {/* Future scope: Tabs for shipment/finance/graphs-specific filters */}
      </div>
    </div>
  );
};

export default FilterPanel;
